// relative
import { energyAnalysisApiSlice } from '../apiSlice';

export const portfolioEnergyGroupSlice = energyAnalysisApiSlice.injectEndpoints(
  {
    endpoints: (builder) => ({
      // Get all requests for an account
      getPortfolioEnergyGroupRequests: builder.query({
        query: ({ account_id }) => ({
          url: `/portfolio_energy_groups/requests/${encodeURIComponent(String(account_id))}`,
          method: 'GET',
        }),
        providesTags: ['PortfolioEnergyGroupGroup'],
      }),

      // Create a new portfolio energy group request
      createPortfolioEnergyGroupRequest: builder.mutation({
        query: (body) => ({
          url: `/portfolio_energy_groups/request`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['PortfolioEnergyGroupGroup'],
      }),

      // Delete a portfolio energy group request
      deletePortfolioEnergyGroupRequest: builder.mutation({
        query: ({ account_id, analysis_type }) => ({
          url: `/portfolio_energy_groups/request/${encodeURIComponent(String(account_id))}/${encodeURIComponent(analysis_type)}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['PortfolioEnergyGroupGroup'],
      }),
    }),
  },
);

export const {
  useGetPortfolioEnergyGroupRequestsQuery,
  useCreatePortfolioEnergyGroupRequestMutation,
  useDeletePortfolioEnergyGroupRequestMutation,
} = portfolioEnergyGroupSlice;
